import React, { PropsWithChildren } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

type TooltipProps = {
    message: string;
    tooltipId?: string;
};
const Tooltip: React.FC<PropsWithChildren<TooltipProps>> = ({
    message,
    children,
    tooltipId = 'my-tooltip',
}) => {
    return (
        <>
            <div
                data-tooltip-id={tooltipId}
                data-tooltip-html={message}
                data-tooltip-place="top"
            >
                {children}
            </div>
            <ReactTooltip id={tooltipId} className="rounded-lg normal-case !z-[9999]" />
        </>
    );
};

export default Tooltip;
